module.exports = __webpack_public_path__ + "img/stelligence.0b8e9b84.png";